import moment from 'moment';
import React, { createRef } from 'react';
import { Container } from '@mui/material';
import TableView from '../../../Components/tableView';
import { minMaxFilterEditor, minMaxFilterFunction } from '../../../Components/tableViewEditors';
import constants from '../../../constants';
import './licensesHistory.scss';
import { useTranslation } from 'react-i18next';

// Aggiungere NFTAssetID in tabella e in alert
const LicensesHistory = () => {
  const { t } = useTranslation();
  const licensesTable = createRef<TableView>();

  /* eslint-disable i18next/no-literal-string */
  const columns = [
    {
      title: t('DATE'),
      field: 'date',
      sorter: 'date',
      //headerFilter: 'input',
      headerSortStartingDir: 'desc',
      headerFilter: minMaxFilterEditor,
      headerFilterFunc: minMaxFilterFunction,
      headerFilterLiveFilter: false,
      formatter: (cell: any) => {
        const locale = (window.navigator as any).userLanguage || window.navigator.language;
        return moment(cell.getValue()).locale(locale).format('DD/MM/YYYY HH:mm');
      }
    },
    {
      title: t('FROM'),
      field: 'from_mail',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('TO'),
      field: 'to_mail',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('LICENSE_TYPE'),
      field: 'license_type',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('PRICE'),
      field: 'price',
      sorter: 'string',
      headerFilter: 'input',
      formatter: (cell: any) => {
        const value = cell.getValue();
        return value ? value.toFixed(2) : '-';
      }
    }
  ];

  return (
      <Container>
        <TableView
        t={t} id={'licences-history'} ref={licensesTable} api={constants.api.getLicensesHistory} columns={columns} />
      </Container>
  );
};

export default LicensesHistory;